import ImageEmbed from './imageEmbed.component';

export default ImageEmbed;
